import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useCrmTheme } from '../../utils/CrmThemeContext';

/** Header control. The label names the mode this click will turn on. */
const CrmThemeToggle: React.FC = () => {
  const { theme, toggle } = useCrmTheme();
  const toDark = theme !== 'dark';
  const label = toDark ? 'Dark mode' : 'Light mode';
  return (
    <button
      type="button"
      className="crm-theme-toggle"
      onClick={toggle}
      aria-label={label}
      title={label}
    >
      {toDark ? <Moon size={18} aria-hidden /> : <Sun size={18} aria-hidden />}
    </button>
  );
};

export default CrmThemeToggle;
